import axios from 'axios';
import fileHelper from './helpers/file';

const DefaultPageSize = 20;

export default {
  /**
   * Upload doc(s) for an event
   */
  upload(teamId, eventId, file, path, parentFolderId) {
    let formFields = {
      file,
      payload: JSON.stringify({ path, parentFolderId }),
      params: JSON.stringify({ teamId, eventId }),
    };
    return fileHelper.uploadForm('/api/upload/eventDoc.create', formFields);
  },

  /**
   * Update doc for an event
   */
  update(teamId, eventId, eventDocId, changes) {
    return axios
      .post('/api/eventDoc.update', {
        params: {
          teamId: teamId,
          eventId: eventId,
          eventDocId: eventDocId,
        },
        payload: changes,
      })
      .then((res) => res.data);
  },

  /**
   * Get a page of docs..
   *
   * @param teamId
   * @param eventId
   * @param pageNumber
   * @param pageSize
   * @param archived (removed from docs non trashed list into trashed)
   * @param deleted (removed from docs trashed list)
   * @returns {*}
   */
  getByEventId(
    teamId,
    eventId,
    pageNumber = 1,
    pageSize = DefaultPageSize,
    archived = false,
    deleted = false,
  ) {
    return axios
      .post('/api/eventDoc.getByEventId', {
        query: {
          page: pageNumber,
          size: pageSize,
          archived,
          deleted,
        },
        params: {
          teamId,
          eventId,
        },
      })
      .then((result) => result.data);
  },

  /**
   *
   * @param teamId
   * @param eventId
   * @param term
   * @param pageNumber
   * @param pageSize
   */
  getByEventIdAndTerm(
    teamId,
    eventId,
    term,
    pageNumber = 1,
    pageSize = DefaultPageSize,
  ) {
    return axios
      .post('/api/eventDoc.getByEventId', {
        query: {
          page: pageNumber,
          size: pageSize,
          term: term || undefined,
        },
        params: {
          teamId,
          eventId,
        },
      })
      .then((result) => result.data);
  },

  /**
   * Get event doc signed URL
   *
   * @param teamId
   * @param eventId
   * @param eventDocId
   */
  getSignedUrl(teamId, eventId, eventDocId, attachment) {
    return axios
      .post('/api/eventDoc.getSignedUrlPublic', {
        query: {
          attachment: attachment,
        },
        params: {
          teamId,
          eventId,
          eventDocId,
        },
      })
      .then((result) => result.data);
  },

  /**
   * Archive an event doc
   */
  archive(teamId, eventId, eventDocId) {
    return axios
      .post('/api/eventDoc.archive', {
        params: { teamId, eventId, eventDocId },
      })
      .then((res) => res.data);
  },

  /**
   * Soft delete an event doc
   */
  softDelete(teamId, eventId, eventDocId) {
    return axios
      .post('/api/eventDoc.softDelete', {
        params: { teamId, eventId, eventDocId },
      })
      .then((res) => res.data);
  },

  /**
   * Restore a archived event doc
   */
  restoreArchived(teamId, eventId, eventDocId) {
    return axios
      .post('/api/eventDoc.restoreArchived', {
        params: { teamId, eventId, eventDocId },
      })
      .then((res) => res.data);
  },
};
